// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__OAa8q","footer__innerCont":"Footer_footer__innerCont__Y2K5F","footer__leftContainer":"Footer_footer__leftContainer__lDML8"};